@if (wheels()?.length !== 0) {
  <div class="wheels-section">
    <div class="wheels-section__header">
      <h2 class="wheels-section__title">My Wheels</h2>
      <button class="wheels-section__create-button" type="button" (click)="createWheelClick.emit()" data-testid="create-new-wheel-button">
        + Create New Wheel
      </button>
    </div>
    <div class="wheels-grid" data-testid="wheels-grid">
      @for (wheel of wheels(); track wheel.id) {
        <wil-admin-tab-wheel-card
          [wheel]="wheel"
          [accountId]="accountId()"
        ></wil-admin-tab-wheel-card>
      }
    </div>
  </div>
} @else {
  <wil-empty-state></wil-empty-state>
}
